import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Antes todas mis plantas se morían. Ahora tengo mi primera huerta funcionando.',
    author: 'María, 34'
  }, {
    quote: 'Pensé que no era para mí… era que no sabía cómo hacerlo.',
    author: 'Lucas, 29'
  }, {
    quote: 'Es la primera vez que entiendo realmente cómo cuidar plantas.',
    author: 'Carolina, 41'
  }, {
    quote: 'Vivo en departamento y pensé que no podía. Sí se puede.',
    author: 'Julián, 37'
  }, {
    quote: 'Es simple, claro y funciona.',
    author: 'Sofía, 32'
  }];
  return <section className="bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-159">
      <div className="max-w-6xl mx-auto" data-id="element-160">
        <h2 className="font-serif text-3xl sm:text-4xl font-black text-center text-[#1A1A1A] mb-10" data-id="element-161">
          💬 Lo que dicen otras personas
        </h2>

        {/* Top row: 3 cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6" data-id="element-162">
          {testimonials.slice(0, 3).map((t, index) => <div key={index} className="bg-neutral-bg rounded-3xl p-6 shadow-md border border-neutral-beige relative transition-all duration-300 hover:-translate-y-2 hover:shadow-xl group flex flex-col" data-id="element-163">
              <div className="absolute -top-3 left-4 text-5xl text-garden-light/30 font-serif font-black group-hover:text-garden-light/50 transition-colors leading-none" data-id="element-164">
                "
              </div>
              <div className="flex text-earth-accent text-sm mb-4 relative z-10" data-id="element-165">
                ★★★★★
              </div>
              <p className="text-gray-800 font-medium italic text-base mb-6 leading-relaxed relative z-10 flex-grow" data-id="element-166">
                {t.quote}
              </p>
              <div className="pt-4 border-t border-neutral-beige/50" data-id="element-167">
                <p className="text-garden-dark font-bold text-sm uppercase tracking-wider" data-id="element-168">
                  — {t.author}
                </p>
              </div>
            </div>)}
        </div>

        {/* Bottom row: 2 cards centered */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-169">
          {testimonials.slice(3).map((t, index) => <div key={index + 3} className="bg-neutral-bg rounded-3xl p-6 shadow-md border border-neutral-beige relative transition-all duration-300 hover:-translate-y-2 hover:shadow-xl group flex flex-col" data-id="element-170">
              <div className="absolute -top-3 left-4 text-5xl text-garden-light/30 font-serif font-black group-hover:text-garden-light/50 transition-colors leading-none" data-id="element-171">
                "
              </div>
              <div className="flex text-earth-accent text-sm mb-4 relative z-10" data-id="element-172">
                ★★★★★
              </div>
              <p className="text-gray-800 font-medium italic text-base mb-6 leading-relaxed relative z-10 flex-grow" data-id="element-173">
                {t.quote}
              </p>
              <div className="pt-4 border-t border-neutral-beige/50" data-id="element-174">
                <p className="text-garden-dark font-bold text-sm uppercase tracking-wider" data-id="element-175">
                  — {t.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}